import http from "../http-common"; 

class FitxesService {
    listFiltreAdminFitxes(data){
        return http.post("/fitxes/acumulats", data);
    }
    getListEntitat(idAmbit, idRegio){
        return http.get("/fitxes/entitat/"+idAmbit+"/"+idRegio);
    }
    getListUnitat(idAmbit, idRegio, idEntitat){
        return http.get("fitxes/unitat/"+idAmbit+"/"+idRegio+"/"+idEntitat);
    }
}

export default new FitxesService();